import { Scenario } from '../model/scenario.model'
import { ScopeConfiguration } from '@app/core/model/scope-version'
import { getQuestionValueByType } from './get-question-value-by-type.util'

export const mapScenario = (scenario: Scenario, configuration: ScopeConfiguration) => {
  scenario.categories
    .sort((c1, c2) => c1.orderIndex - c2.orderIndex)
    .forEach((category) => {
      category.questions = category.questions
        .filter((q) => !!q)
        .map((q) => ({ ...q, categoryId: category.id }))
        .sort((q1, q2) => q1.orderIndex - q2.orderIndex)

      const categoryConfiguration = configuration[category.id]
      if (categoryConfiguration)
        category.questions = category.questions.map((question) => ({
          ...question,
          value: getQuestionValueByType(question?.type, categoryConfiguration?.[question.id]),
        }))
    })
  return scenario
}
